import { createContext, useContext } from 'react'

export type Theme = 'light' | 'dark'

export const themeStorageKey = 'vite-ui-theme'

export function readTheme(defaultTheme: Theme): Theme {
  try {
    const savedTheme = localStorage.getItem(themeStorageKey)
    if (savedTheme === 'light' || savedTheme === 'dark') return savedTheme
  } catch {
    // Theme switching still works when browser storage is unavailable.
  }
  return defaultTheme
}

export const ThemeContext = createContext<{
  theme: Theme
  setTheme: (theme: Theme) => void
} | undefined>(undefined)

export function useTheme() {
  const context = useContext(ThemeContext)
  if (!context) throw new Error('useTheme must be used within a ThemeProvider')
  return context
}
